import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {mailingListView_template} from "../components/templates/mailingListView_template";
import {getBrandInfoFromVnAppZone} from "../utils/BrandHelper";
import {RESTRICTED_MAILING_LIST_EDIT_BRANDS} from "../utils/consts/brand";

declare var ko: any;
declare var page: any;

export class mailing_list_view extends vnModule_knockoutJS {

    protected mailingListView: mailingListView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.mailingListView = new mailingListView_template("mailingListView", this.viewModel, this);

        const brand = getBrandInfoFromVnAppZone(this.getVnAppZone());
        if (brand && RESTRICTED_MAILING_LIST_EDIT_BRANDS.indexOf(brand.shortName) !== -1) {
            this.mailingListView.setEditRestricted(true);
        }

        return [this.mailingListView.build()];
    }

    protected getModuleName(): string {
        return "mailing_list_view";
    }

    fillPage() {
        this.getMailingListDataForView()
    }

    private getMailingListDataForView() {

        this.loadingIn(this.mailingListView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/mailingList/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetMailingListDataForView;
        this.XHRHdl.execute();
    }

    private onGetMailingListDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.mailingListView.setMailingListData(responseParsed.data);
            });

            obj.loadingOut(obj.mailingListView.builtTemplate);
        }
    }

    protected onClickEditMailingList(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/mailing-lists/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/mailing-lists/")
    }
}



// WEBPACK FOOTER //
// ./js/modules/mailing_list_view.ts